// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"I7cRv","headline":"_2sKo3","stories":"_36ibL"};